import { ComponentType } from 'react';
import ReactDOM from 'react-dom';


const root = document.getElementById('root');

export type PortalProps = {
    children: JSX.Element;
}

export const Portal: ComponentType<PortalProps> = ({ children }) =>
    root && ReactDOM.createPortal(children, root);
